import { useState, useEffect, useCallback } from 'react';
import AppInfoApiClient from '../../api/appInfoApiClient';
import { FRONTEND_VERSION } from '../../version';

/**
 * Custom hook for managing application version information
 * Fetches backend version from API and gets frontend version from version constant
 * @returns {Object} { backendVersion, frontendVersion, loading, error }
 */
const useAppVersion = () => {
    const [backendVersion, setBackendVersion] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    
    // Get frontend version from version constant
    const rawVersion = FRONTEND_VERSION || '0.0.0';
    const frontendVersion = rawVersion.startsWith('v') ? rawVersion : `v${rawVersion}`;

    /**
     * Fetch backend version from API
     */
    const fetchBackendVersion = useCallback(async () => {
        try {
            setLoading(true);
            setError(null);
            
            console.log('Fetching app info from API...');
            const appInfo = await AppInfoApiClient.getAppInfo();
            console.log('App info received:', appInfo);
            setBackendVersion(appInfo.backendVersion || 'v0.0.0');
        } catch (err) {
            console.error('Error fetching app info:', err);
            setError(err.message || 'Failed to load version information');
            // Set a fallback version on error
            setBackendVersion('v0.0.0');
        } finally {
            setLoading(false);
        }
    }, []);

    // Initial fetch
    useEffect(() => {
        fetchBackendVersion();
    }, [fetchBackendVersion]);

    return {
        backendVersion: backendVersion || 'v0.0.0',
        frontendVersion,
        loading,
        error
    };
};

export default useAppVersion;

